module.exports = __webpack_public_path__ + "static/DisabledMedicalExpenses-bf9a770ff6a3865245a4d11f869c9ac4.png";